document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('register-interest-modal');
  if (!modal) return;

  function openModal() {
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-open-register-modal]');
    if (trigger) {
      event.preventDefault();
      var listing = trigger.getAttribute('data-listing');
      var bodyField = modal.querySelector('input[name="contact[body]"]');
      if (bodyField) {
        bodyField.value = listing
          ? 'Property enquiry for "' + listing + '" via Register Your Interest form on ' + window.location.hostname
          : 'New enquiry submitted via Register Your Interest form on ' + window.location.hostname;
      }
      openModal();
    }
    if (event.target.closest('[data-close-register-modal]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  // Auto-open if the form was just submitted (Shopify redirects back with ?contact_posted=true style state)
  if (window.location.hash === '#RegisterInterestForm' || modal.querySelector('.register-modal__success')) {
    openModal();
  }
});
